(function SourceList($, Adzuki)
{
	"use strict";

	var $clients_in_source     = $(".clients-in-source"),
		$clients_not_in_source = $(".clients-not-in-source"),
		$source_controls       = $(".source-controls");

	$source_controls.on('click', '.btn.add-all', function addAllClients(e) {
		e.preventDefault();
		$clients_not_in_source.find("option").each(function moveAll(key, value) {
			var $element = value;
			$clients_in_source.append($element);
		});
	});

	$source_controls.on('click', '.btn.add-selected', function addSelectedClients(e) {
		e.preventDefault();
		$clients_not_in_source.find("option:selected").each(function moveSelected(key, value) {
			var $element = value;
			$clients_in_source.append($element);
		});
	});

	$source_controls.on('click', '.btn.remove-selected', function removeSelectedClients(e) {
		e.preventDefault();
		$clients_in_source.find("option:selected").each(function removeSelected(key, value) {
			var $element = value;
			$clients_not_in_source.append($element);
		});
	});

	$source_controls.on('click', '.btn.remove-all', function removeAllClients(e) {
		e.preventDefault();
		$clients_in_source.find("option").each(function removeAll(key, value) {
			var $element = value;
			$clients_not_in_source.append($element);
		});
	});

	// functions
}(jQuery, window.Adzuki || {}));